module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_3_1.04e475e3.png";